<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Chamados</div>
      </div>
      <div class="card-body mt-4">
        <div class="row mb-4">
          <div class="col-md-2" align="left">
            <button class="btn btn-add" type="button" @click="collapseToggle">
              <i class="fas fa-filter"></i> Filtros
            </button>
          </div>
          <div class="col-md-2">
            <button class="btn btn-add" type="button" @click="getEntity">
              <i class="fas fa-sync-alt"></i> Atualizar
            </button>
          </div>
        </div>

        <div class="row mb-3" v-if="collapse == 1">
          <div class="col-md-6">
            <label>Filtrar Sala</label>
            <v-select
              :options="rooms"
              label="title"
              :reduce="(rooms) => rooms.id"
              multiple
              class="style-chooser"
              v-model="filters.room_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-6">
            <label>Filtrar Solicitante</label>
            <v-select
              :options="users"
              label="name"
              :reduce="(users) => users.id"
              multiple
              class="style-chooser"
              v-model="filters.user_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label>Status</label>
            <v-select
              :options="status"
              label="text"
              :reduce="(status) => status.id"
              multiple
              class="style-chooser"
              v-model="filters.status"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label>Data de Início</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.date_start"
            />
          </div>
          <div class="col-md-4 mt-2">
            <label>Data Final</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.date_end"
            />
          </div>
          <div class="col-md-12 mt-4 mb-3" align="center">
            <button class="btn btn-add" @click="getEntity">Pesquisar</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table" style="font-size: 14px">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Assunto</th>
                  <th scope="col">Solicitante</th>
                  <th scope="col">Data</th>
                  <th scope="col">Sala/Estação de Trabalho</th>
                  <th scope="col">Status</th>
                  <th scope="col">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ticket in tickets" :key="ticket.id">
                  <td>{{ ticket.id }}</td>
                  <td>{{ ticket.subject }}</td>
                  <td>{{ ticket.opened_by.name }}</td>
                  <td>{{ ticket.created_at }}</td>
                  <td>
                    {{
                      ticket.reserve.room
                        ? ticket.reserve.room.title
                        : ticket.reserve.workstation.title
                    }}
                  </td>
                  <td>
                    <h6>
                      <span
                        v-if="ticket.status == 1"
                        class="badge badge-warning"
                        >Aguardando</span
                      >
                      <span
                        v-if="ticket.status == 2"
                        class="badge badge-primary"
                        >Em andamento</span
                      >
                      <span
                        v-if="ticket.status == 3"
                        class="badge badge-success"
                        >Finalizado</span
                      >
                    </h6>
                  </td>
                  <td>
                    <router-link
                      class="btn btn-add"
                      :to="'/tickets/manage/' + ticket.id"
                    >
                      <i class="fas fa-eye"></i>
                    </router-link>
                  </td>
                </tr>
                <tr v-if="tickets.length == 0">
                  <td colspan="8" align="center">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <pagination
              :records="total"
              :options="options"
              :per-page="10"
              @paginate="getEntity"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";
export default {
  data: function () {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      users: [],
      total: 0,
      page: 1,
      collapse: 0,
      tickets: [],
      rooms: [],
      filters: {
        status: [1, 2],
      },
      dataModal: null,
      status: [
        {
          id: 1,
          text: "Aguardando",
        },
        {
          id: 2,
          text: "Em andamento",
        },
        {
          id: 3,
          text: "Finalizado",
        },
      ],
    };
  },
  components: { vSelect, Pagination },
  methods: {
    getEntity(page) {
      const self = this;
      self.page = page ? page : self.page;
      const api = self.$store.state.api + "tickets/manage/?page=" + self.page;

      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.tickets = response.data.data;
          self.total = response.data.total;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    collapseToggle() {
      if (this.collapse == 1) {
        this.collapse = 0;
      } else {
        this.collapse = 1;
      }
    },
    changeStatus(status) {
      const self = this;
      const api = self.$store.state.api + "services_additionals/change-status";

      self.$http
        .post(api, { additional_id: self.dataModal.id, status: status })
        .then(() => {
          self.getEntity();
          self.$message(
            "Sucesso",
            "Adicional atualizado com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRooms: function () {
      const self = this;
      const api = self.$store.state.api + "rooms?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.rooms = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getEntity();
    this.getRooms();
    this.getUsers();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Tickets/Crud.vue